import { LinearProgress, Link, Stack, styled, Tooltip } from '@mui/material';

import { colors } from '../theme/theme';

export const CommonLoginWrapper = styled(Stack)(({ theme }) => ({
    backgroundColor: colors.bluePreset[110],
    height: '100dvh',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(3),
    '& .loginCard': {
        maxWidth: '450px',
        width: '100%',
        margin: '0 auto',
        backgroundColor: colors.fullWhite,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 16,
        padding: theme.spacing(1),
    },
    '& .mainTitle': {
        fontWeight: '600',
        color: colors.fullBlack,
        marginBottom: theme.spacing(1.5),
        textAlign: 'center',
    },
    '& .registerLoginCardBody': {
        [theme.breakpoints.up('xl')]: {
            height: 'auto',
            overflow: 'hidden',
        },
        maxHeight: 'calc(100dvh - 254px)',
    },
    '& .loginCardBody': {
        [theme.breakpoints.up('xl')]: {
            height: 'auto',
            overflow: 'hidden',
        },
        maxHeight: 'calc(100dvh - 190px)',
    },
    '& .commonLoginCard': {
        overflow: 'auto',
        width: '100%',
        padding: theme.spacing(0, 4, 4),
    },
}));

export const LinkTextWrapper = styled(Link)(() => ({
    color: colors.bluePreset[30],
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
        color: colors.bluePreset[10],
    },
    '&:visited': {
        color: colors.bluePreset[30],
    },
    '&:active': {
        color: colors.bluePreset[30],
    },
}));

export const PassWordGuidelinesWrapper = styled(Stack)(({ theme }) => ({
    border: `1px solid ${colors.greyPreset[30]}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    width: '100%',
}));

export const LoginTabsWrapper = styled(Stack)(({ theme }) => ({
    '& .MuiTabs-root': {
        backgroundColor: colors.greyPreset[20],
        borderRadius: theme.spacing(1),
        padding: theme.spacing(0.5),
        minHeight: 0,
        '& .MuiTab-root': {
            ...theme.typography.body2,
            padding: theme.spacing(1.25),
            width: '50%',
            borderRadius: theme.spacing(1),
            fontWeight: 600,
            color: colors.greyPreset[80],
            minHeight: 36,
            '&.Mui-selected': {
                background: colors.fullWhite,
                color: theme.palette.text.primary,
            },
        },
        '& .MuiTabs-indicator': {
            display: 'none',
        },
    },
}));
export const PrimaryIconWrapper = styled(Stack)(() => ({
    '& span': {
        color: colors.primaryLight[100],
    },
}));

export const LinearProgressWrapper = styled(LinearProgress)(({ theme }) => ({
    height: 6,
    borderRadius: 4,
    backgroundColor: colors.greyPreset[20],
    '& .MuiLinearProgress-bar': {
        backgroundColor: colors.primaryLight[70],
        borderRadius: theme.spacing(2),
    },
}));
export const CommonTooltip = styled(Tooltip)(() => ({
    visibility: 'visible',
}));

export const CommonScrollbarStyles = styled(Stack)(() => ({
    maxHeight: 'calc(100dvh - 260px)',
    overflowY: 'auto',
    pr: 1,
    '& .MuiPaper-root': {
        borderRadius: '12px !important',
        bgcolor: colors.greyPreset[90],
        p: 1.5,
    },
    '&::-webkit-scrollbar': {
        width: '8px',
    },
    '&::-webkit-scrollbar-track': {
        bgcolor: colors.primaryLight[5],
        borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
        bgcolor: colors.primaryLight[30],
        borderRadius: '10px',
        '&:hover': {
            bgcolor: colors.primaryLight[70],
        },
    },
}));

// Visually hidden class for accessibility - hides content visually but keeps it available for screen readers
export const VisuallyHiddenStyles = styled('span')({
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: '0',
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: '0',
});
export const AutoPayBadgeStyles = styled(Stack)(() => ({
    height: 'fit-content',
    borderRadius: 24,
    backgroundColor: colors.successPreset[40],
    padding: '4px 8px',
    color: colors.successPreset[50],
    border: `1px solid ${colors.successPreset[50]}`,
    gap: 4,
    '& span': {
        fontSize: 16,
        fontWeight: 600,
    },
}));

// Neutral counterpart of AutoPayBadgeStyles for contracts that have no autopay and can't enable it here.
export const AutoPayOffBadgeStyles = styled(Stack)(() => ({
    height: 'fit-content',
    borderRadius: 24,
    backgroundColor: colors.greyPreset[5],
    padding: '4px 8px',
    color: colors.greyPreset[150],
    border: `1px solid ${colors.greyPreset[20]}`,
    gap: 4,
    '& span': {
        fontSize: 16,
        fontWeight: 600,
    },
}));

export const AutopayInfoWrapper = styled(Stack)(() => ({
    borderRadius: 8,
    backgroundColor: colors.bluePreset[50],
    padding: 12,
    color: colors.bluePreset[30],
    border: `1px solid ${colors.bluePreset[60]}`,
    gap: 8,
    '& span': {
        fontSize: 20,
    },
}));
